import { PERMISSION_GET_OK_ACTION } from './actions.js'

/**
 * Reducer for handling permissions.
 */
export function permission (state = { items: [] }, action) { // eslint-disable-line
  switch (action.type) {
    case PERMISSION_GET_OK_ACTION:
      return Object.assign({}, state, {
        items: action.items.slice()
      })
    default:
      return state
  }
}
